import React from 'react'
import ReactWOW from 'react-wow'
import { Link } from 'gatsby'
import svgBanner from '../../assets/images/svgBanner.svg'
const Banner = () => {
    return (
        <div className="it-services-banner">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="main-banner-content">
                            <ReactWOW delay='.1s' animation='fadeInLeft'>
                                <h1>Accelerating Innovation</h1>
                            </ReactWOW>

                            <ReactWOW delay='.1s' animation='fadeInLeft'>
                                <div className="d-flex justify-content-around justify-content-md-start">
                                    <p>We augment your people, processes, products or things to build an intelligent enterprise</p>
                                </div>
                            </ReactWOW>

                            <ReactWOW delay='.1s' animation='fadeInRight'>
                                <div className="btn-box">
                                    <Link to="/contact" className="default-btn">
                                        {/* <i className="flaticon-right"></i>  */}
                                        Learn More <span></span>
                                    </Link>
                                </div>
                            </ReactWOW>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12 col-12 p-0">
                        <ReactWOW delay='.1s' animation='fadeInUp'>
                            <div className="main-banner-image p-0">
                                <img src={svgBanner} alt="banner" />
                            </div>
                        </ReactWOW>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner